import { Text, Box, ColorModeScript, color } from "@chakra-ui/react";
import "./App.css";
import Sidebar from "./Components/common/Sidebar";
import Routing from "./routing/Routing";

function App() {
  return <Routing />;
}

export default App;
